import i18n from 'i18next';
import jQuery from 'jquery';
import _ from 'lodash';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

UI.View({
    name: 'order_products',
    model: Order,
    el: '[data-view="basket"]',
    templates: {
        product: jQuery('[data-template="order-product"]').html(),
    },
    initialize() {
        this.$el.localize();
    },
    show() {
        this.jQuery('[data-empty-basket]').addClass('m2g-hidden');
        this.jQuery('[data-basket]').removeClass('m2g-hidden');
    },
    hide() {
        this.jQuery('[data-empty-basket]').removeClass('m2g-hidden');
        this.jQuery('[data-basket]').addClass('m2g-hidden');
    },
    updateProductsQuantity(quantity) {
        quantity ? this.show() : this.hide();
        jQuery('[data-basket-products]').attr(
            'data-count',
            Order.getProducts().length
        );
    },
    ready() {
        this.jQuery('[data-spinner]').hide();
    },
    restrictedProductsRemovedWarning(products) {
        const options = {
            id: 'products-removed',
            title: i18n.t('order.products:restricted_product_warning_title', {
                count: products.length,
            }),
            body: i18n.t('order.products:restricted_product_warning_body', {
                count: products.length,
                product_name: products[0].menu_product.name,
            }),
        };
        _.delay(function() {
            UI.centeredAlert(options);
        }, 2000);
    },
    model_listeners: {
        ready: 'ready',
        addProduct: 'createBasketProductView',
        updateProductsQuantity: 'updateProductsQuantity',
        restrictedProductsRemovedWarning: 'restrictedProductsRemovedWarning',
    },

    DOM_listeners: {
        'click [data-menu]': function() {
            UI.trigger('showMenuList');
        },
    },

    /**---------------------------------------------------------------------
     * Order Product
     */
    createBasketProductView(product) {
        const basket_view = this;
        Mobi2Go.UI.View({
            name: `order_product#${product.cid}`,
            model: product,
            initialise() {
                basket_view.show();
                this.render();

                if (Order.isReady() && (!UI.Modal || !UI.Modal.isOpen())) {
                    _.defer(this.alertAdded); // Don't alert if order hasn't loaded
                }

                UI.bind('deletingFocusedBasketProduct', this.focusIfFirst);
            },
            render() {
                const $html = jQuery(basket_view.templates.product(this.model));

                if (this.$el) {
                    this.$el.replaceWith($html);
                } else {
                    $html.prependTo(
                        basket_view.jQuery('[data-basket-products]')
                    );
                }
                this.setEl($html);

                if (Order.isReady()) {
                    const that = this;
                    setTimeout(function() {
                        that.highlight();
                    }, 50);
                }
            },
            focusIfFirst() {
                if (
                    Order.getProducts() &&
                    _.last(Order.getProducts()).cid === this.model.cid
                ) {
                    this.$el.focus();
                }
            },

            DOM_listeners: {
                // Edit product on click
                click() {
                    Mobi2Go.UI.trigger('editProduct', this.model);
                },
                keydown(e) {
                    const key_code = e.keyCode;

                    switch (key_code) {
                        case 13: // Enter
                            Mobi2Go.UI.trigger('editProduct', this.model);
                            break;
                        case 46: // Delete
                        case 8: // Backspace
                            UI.unbind(
                                'deletingFocusedBasketProduct',
                                this.focusIfFirst
                            );
                            Order.removeProduct(this.model);
                            UI.trigger('deletingFocusedBasketProduct');
                            break;
                    }
                },
                'click [data-remove]': function(e) {
                    Order.removeProduct(this.model);
                    e.stopPropagation();
                },
            },
            model_listeners: {
                updateMenuProduct: 'render',
                updateComment: 'render',
                updateTotal: 'render',
                updateQuantity: 'updateQuantity',
                updateSize: 'updateSize',
                updateDisplayModifiers: 'render',
                updateTotalDiscounted: 'render',
                removeFromOrder: 'removeFromOrder',
                addSubProduct: 'render',
                updateModifierSelection: 'render',
            },
            updateMenuProduct(menu_product) {},
            updateTotal(total, list_total) {
                this.jQuery('[data-total]').html(
                    i18n.t('common:price', { price: list_total })
                );
                this.highlight();
            },
            updateQuantity(new_quantity) {
                this.$el.attr('data-quantity', new_quantity);
                this.jQuery('[data-quantity-display]').text(new_quantity);
            },
            updateSize(new_size) {
                this.jQuery('[data-size]').text(` (${new_size})`);
            },
            removeFromOrder() {
                this.$el.remove();
            },
            highlight() {
                const { $el } = this;
                setTimeout(
                    function() {
                        UI.helpers.highlightElement($el);
                    },
                    UI.page && UI.page.currentPage() !== 'main' ? 500 : 0
                );
            },
            alertAdded() {
                if (Mobi2Go.app.isMobileUI()) {
                    return;
                }

                const $product_el = this.$el;
                const body = i18n.t('order.products:click_on_item');
                const is_mobile = Mobi2Go.app.isMobileUI();

                UI.helpers.scrollTo(
                    basket_view.$el,
                    function() {
                        UI.alert({
                            id: 'item-added',
                            title: i18n.t('order.products:item_added'),
                            body,
                            temp: true,
                            primary_button: null,
                            el: is_mobile ? basket_view.$el : $product_el,
                            // Unfades sections
                            onClose: UI.views.order_sections.fadeSections,
                            placement: is_mobile ? 'top' : 'left',
                        });
                    },
                    false,
                    -100
                );

                // A very uncool dependency - change to use events
                if (!is_mobile) {
                    UI.views.order_sections.fadeSections(true, 'basket');
                }
            },
        });
    },
});
